<template>
  <!-- ボトムバー右端のハイリスク疑い報告。3相談画面（いつでも相談 / 夜間相談 / 日中助産師相談）で共有する。
       報告可否は Launcher が GET /new で判定し、未入力時は入力案内をボタン下に表示する。 -->
  <div
    v-if="isPermitted && reportable"
    class="high-risk-report-bar-action-wrapper"
  >
    <v-btn
      class="high-risk-report-bar-action"
      variant="flat"
      color="#c8384f"
      @click="$emit('open')"
    >
      ハイリスク疑いを報告
    </v-btn>
    <p
      v-if="riskAssessmentRequired"
      class="high-risk-report-bar-action__notice"
    >
      ※まずはリスクアセスメントを入力ください
    </p>
  </div>
</template>

<script>
import { canUseHighRiskReport } from "@/vue/entities/high-risk-report";
import { FEATURE_FLAGS } from "@/vue/shared/utils/featureFlags";

export default {
  name: "HighRiskReportBarAction",
  emits: ["open"],
  props: {
    reportable: {
      type: Boolean,
      default: false
    },
    riskAssessmentRequired: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isPermitted() {
      // フラグB（#2599）有効時はボタンを出さない
      if (this.$store?.getters?.isFeatureEnabled?.(FEATURE_FLAGS.hideHighRiskBarActions) === true) return false;
      return canUseHighRiskReport(this.$store?.getters?.capabilities);
    }
  }
};
</script>

<style lang="scss" scoped>
.high-risk-report-bar-action {
  // 同じバーに並ぶ他のボタンと高さを揃える。
  height: 40px;
  color: #fff;
}

.high-risk-report-bar-action-wrapper {
  position: relative;
}

.high-risk-report-bar-action__notice {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin: -4px 0 0;
  color: #c8384f;
  font-size: 11px;
  line-height: 12px;
  text-align: center;
  white-space: nowrap;
}
</style>
